import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { Checkbox  } from 'primereact/checkbox';

import { SET_VALUES_ADMIN } from '@constants/actionType';

import store from '@store';


class PerfilForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileSelect: [],
      errors: []
    };
  }

  componentDidMount() {
    const { _profileSelect } = this.props;

    if (_profileSelect) {
      this.setState({ profileSelect: _profileSelect });
    }
    this.setState({ loadingPage: false });
  }

  

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeCheck = (e) => {
    const { profileSelect } = this.state
    const profileSelectVisible = [...profileSelect];
    if(e.checked)
    profileSelectVisible.push(e.value);
    else
    profileSelectVisible.splice(profileSelectVisible.indexOf(e.value), 1);

    this.setState(
      {profileSelect: profileSelectVisible},
      () => this.validateFieldsOnchange(`profileSelect`, true)
    );
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { profileSelect } = this.state
    let errors = {}
    if (!profileSelect.length ) errors = { ...errors, [`profileSelect`]: 'profileSelect es requerido' }
    this.setState({errors})
    return errors
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { success } = this.props
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    await this.setValuesToStateGlobal();
    success()
  };

  setValuesToStateGlobal = async () => {
    const { profileSelect } = this.state;


    await store.dispatch({
      type: SET_VALUES_ADMIN,
      payload: {
        profileSelect
      }
    });
    return true
  };
  

  render() {
    const { t, btnSubmitLoading, history, user, onBack, profilesCurrentCatalog  } = this.props;

    const {
      loadingPage,
      errors,
      profileSelect
    } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);

    
    const renderProfilesOption = () => profilesCurrentCatalog.map(item => (
      <div className="p-field-checkbox" key={item.label}>
        <Checkbox
          inputId={`cb${item.id}`}
          name="profileSelect"
          value={item.id}
          onChange={this.onChangeCheck}
          checked={profileSelect.indexOf(item.id) !== -1}
          className={classNames({
            'p-invalid': isFormFieldValid(`profileSelect`),
          })}
        />
        <label >{item.label}</label>
      </div>
    ))


    if (loadingPage) return true;

    return (
      <form onSubmit={this.onSubmit} autoComplete="false">
        <div className="p-fluid p-grid p-mb-4">
          <div className="p-col-6 p-mb-5">
            <label className="p-text-bold">{t('Nombre del usuario')}</label> <br/>
            <label>{user?.nombre || 'N/A'} </label>
          </div>
          <div className="p-col-12 p-field">
            <label  className="p-text-bold">{t('Seleccione el o los perfiles para el usuario')}</label> <br/>
            { renderProfilesOption() }
          </div>
        </div>
        <div className="p-col-12 footer-btn">
          <div className="p-d-flex p-jc-between">
            <Button
              label={t('Regresar')}
              type="button"
              className="p-button-secondary"
              onClick={() => onBack()}
            />
             <Button
             label={t('Continuar')}
             type="submit"
             className="p-button-primary"
             loading={btnSubmitLoading}
           />
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.admins.user,
  _profileSelect: state.admins.profileSelect,
  profilesCurrentCatalog: state.catalogs.profilesCurrentCatalog
});

const mapDispatchToProps = {
  
};


export default withRouter(compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(PerfilForm));
